module.exports = __webpack_public_path__ + "static/media/car.5950d1d4.svg";